import * as _ from '@mui/icons-material';
import propTypes from 'prop-types';
import './styles.css';
import LoadingButton from '@mui/lab/LoadingButton';
import { Tooltip } from '@mui/material';

const ActionButton = (props) => {

    const {
        href,
        onClick,
        variant,
        disabled,
        label,
        loading,
        icon,
        endIcon,
        startIconName,
        endIconName,
        styleProps,
        toolTip,
    } = props;

    const StartIconTag = _[`${startIconName}`];
    const EndIconTag = _[`${endIconName}`];

    const handleClick = () => {
        onClick();
    };

    return (
        <Tooltip title={toolTip}>
            <span>
                <LoadingButton
                    variant={variant}
                    href={href}
                    size="large"
                    startIcon={icon ? icon : startIconName && <StartIconTag />}
                    endIcon={endIcon ? endIcon : endIconName && <EndIconTag />}
                    loading={loading}
                    onClick={handleClick}
                    disabled={disabled}
                    loadingPosition="start"
                    // fullWidth
                    sx={styleProps}
                >
                    <p className={`actionButtonLabel`} style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', margin: 0, textTransform: "none"}}>{label}</p>
                </LoadingButton>
            </span>
        </Tooltip>
    );
}

ActionButton.propTypes = {
    onClick: propTypes.func.isRequired,
    variant: propTypes.oneOf(['text', 'contained', 'outlined']),
    disabled: propTypes.bool,
    loading: propTypes.bool,
    label: propTypes.string,
    href: propTypes.string,
    startIconName: propTypes.string,
    endIconName: propTypes.string,
    styleProps: propTypes.object,
    toolTip: propTypes.string,
    icon: propTypes.element,
    endIcon: propTypes.element
}

ActionButton.defaultProps = {
    variant: "contained",
    disabled: false,
    loading: false,
    label: "",
    href: "",
    startIconName: '',
    endIconName: '',
    styleProps: {
     padding: '8px 30px'
    },
    toolTip: '',
    icon: null,
    endIcon: null
}

export default ActionButton;